var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.5 0C7.85 0 0 7.85 0 17.5S7.85 35 17.5 35 35 27.15 35 17.5 27.15 0 17.5 0zm4.35 18.12H19v10.14H14.8V18.12h-2v-3.59h2v-2.32c0-1.66.79-4.26 4.25-4.26l3.13.01v3.49H19.9c-.37 0-.9.18-.9.97v2.11h3.22l-.37 3.59z","fill":"currentColor","fillRule":"nonzero"}));
}

Facebook.defaultProps = {"viewBox":"0 0 35 35"};

module.exports = Facebook;

Facebook.default = Facebook;
